import React from 'react'
import update from 'immutability-helper';

import StatusBar from './StatusBar'
import EditorBar from './EditorBar'
import InfoBar from './InfoBar'
import NavigatorBar from './NavigatorBar'

import { levelRenderer } from '../../../core/graphic_engine/controllers/LevelRenderer.js'

export default class Editor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // #  Prepare toggle states used to switch the state of the status bar
            toggles: {
                freeRoam: "active",
                editMode: "disabled"
            }
        }
    }

    componentDidMount() {
    }
    
    componentWillUpdate(nextProps, nextState) {
    }

    handleToggleFreeRoam() {
        var cur = this.state.toggles.freeRoam;
        var newCur;
        if(cur == "active") {
            newCur = "disabled";
        } else {
            newCur = "active";
        }

        this.setState({
            toggles: update(this.state.toggles, {
                freeRoam: {$set: newCur}
            })
        });
        levelRenderer.toggleFreeRoam();
    }

    toggleEditMode() {
        var cur = this.state.toggles.editMode;
        var newCur;
        if(cur == "active") {
            newCur = "disabled";
        } else {
            newCur = "active";
        }

        this.setState({
            toggles: update(this.state.toggles, {
                editMode: {$set: newCur}
            })
        });
        // #  Each time edit mode is triggered, we need to notify graphics engine
        this.triggerLevelRendererEditMode(newCur);
    }
    zoomIn() {
        levelRenderer.zoomIn();
    }
    zoomOut() {
        levelRenderer.zoomOut();
    }
    rotateLeft() {
        levelRenderer.rotateLeft();
    }
    rotateRight() {
        levelRenderer.rotateRight();
    }
    updatePerspectiveCamera() {
        levelRenderer.updatePerspectiveCamera();
    }
    triggerLevelRendererEditMode(newCur) {
        levelRenderer.toggleEditMode(newCur);
    }
    render(){
        return (
            <div>
                <StatusBar toggles={this.state.toggles} buildingID={this.props.buildingID} buildingData={this.props.buildingData} levelID={this.props.levelID}/>
                <NavigatorBar
                    toggles={this.state.toggles}
                    toggleEditMode={this.toggleEditMode.bind(this)} 
                    toggleFreeRoam={this.handleToggleFreeRoam.bind(this)}
                    zoomIn={this.zoomIn.bind(this)} 
                    zoomOut={this.zoomOut.bind(this)} 
                    rotateLeft={this.rotateLeft.bind(this)}
                    rotateRight={this.rotateRight.bind(this)}
                    updatePerspectiveCamera={this.updatePerspectiveCamera.bind(this)}
                    buildingID={this.props.buildingID} 
                    buildingData={this.props.buildingData} 
                    levelID={this.props.levelID}
                    totalBuildingLevel={this.props.totalBuildingLevel}
                />
                <InfoBar buildingID={this.props.buildingID} buildingData={this.props.buildingData} levelID={this.props.levelID}/>
                <EditorBar triggerLevelRendererEditMode={this.triggerLevelRendererEditMode.bind(this)} editMode={this.state.toggles.editMode} buildingID={this.props.buildingID} buildingData={this.props.buildingData} levelID={this.props.levelID}/>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Graphics/Editor/Editor.jsx